import insuranceAutomatic from './InsuranceAutomatic'

export default insuranceAutomatic
